<template>
  <div class="developer">
    <div class="dropdown-divider"/>
    <a ref="showWindowButton" :width="75" :height="'auto'" href="#" :theme="'material'" class="dropdown-item pl-3"
       @click="showWindowButtonClicked()">
      <fa icon="info" fixed-width/>
      {{ $t('info') }}
    </a>
    <div id="jqxWidget">
      <JqxWindow ref="window"
                 :width="380" :height="340"
                 :showCollapseButton="true"
                 :initContent="init"
                 :maxHeight="400" :maxWidth="500" :minHeight="200" :minWidth="160" :theme="'material'"
                 :autoOpen="false" :popupZIndex="10000">
        <div>
                <span>
                    {{ appName }}
                </span>
        </div>
        <div>
          <JqxTabs ref="tab" :autoCreate="false" :theme="'material'">
            <ul style="margin-left: 5px;">
              <li>Info</li>
              <li>Technical info</li>
            </ul>
            <div>
              <p></p>
              <ul>
                <li><strong>Name software: </strong>{{ appName }}</li>
                <li><strong>Version: </strong>0.1.1</li>
                <li><strong>Last update: </strong>25/01/2019</li>
                <li><strong>Powered by: </strong>Nicholas Rabellino</li>
                <p></p>
                <li><strong>HotLine: </strong>388 39 45 058 - 011 01 20 975</li>
                <li><strong>Email assistance: </strong>infoqcserve@gmail.com</li>
                <p><img :src="'/styles/images/nerdmessage.png'" width="60px" class="rounded-circle profile-photo mr-1"/>
                </p>
              </ul>
            </div>
            <div>
              <p></p>
              <ul>
                <li>Developed with <strong>Vue2js - Vuex - Laravel 5 - PHP7 - JavaScript - MySql </strong></li>
                <li> {{ appName }} is a <strong>SPA</strong> (Single Page Application).<p>
                  It is able to show dynamic contents without ever reloading the page.</p>
                </li>
                <li>It is an APP for industry 4.0 prepared for IoT integration.</li>
                <li>Developed to simplify the life of operators.</li>
                <li>Simple is better!</li>
                <li class="pull-right">Written by: Nicholas
                  Rabellino <img :src="user.photo_url" width="40px" class="rounded-circle profile-photo mr-1"/>
                </li>
                <li><a href="https://quellocheserve.it" target="_blank">quellocheserve.it</a>
                </li>
              </ul>
            </div>
          </JqxTabs>
        </div>
      </JqxWindow>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import JqxWindow from '~jqx/jqwidgets-vue/vue_jqxwindow.vue';
  import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';
  import JqxButton from '~jqx/jqwidgets-vue/vue_jqxbuttons.vue';
  import JqxCheckbox from '~jqx/jqwidgets-vue/vue_jqxcheckbox.vue';

  export default {
    components: {
      JqxWindow,
      JqxTabs,
      JqxButton,
      JqxCheckbox
    },
    data: () => ({
      appName: window.config.appName
    }),

    mounted: function () {
      let jqxWidget = document.getElementById('jqxWidget');
      let offsetLeft = jqxWidget.offsetLeft;
      let offsetTop = jqxWidget.offsetTop;
      this.$refs.window.position = 'top,right';
    },
    computed: mapGetters({
      user: 'auth/user',
    }),
    methods: {
      init: function () {
        let options = {width: "100%", height: "99%"};
        this.$refs.tab.createComponent(options);
      },
      showWindowButtonClicked: function () {
        this.$refs.window.open();
      },
      hideWindowButtonClicked: function () {
        this.$refs.window.close();
      },
      resizeChange: function (event) {
        if (event.args.checked) {
          this.$refs.window.resizable = true;
        } else {
          this.$refs.window.resizable = false;
        }
      },
      dragChange: function (event) {
        if (event.args.checked) {
          this.$refs.window.draggable = true;
        } else {
          this.$refs.window.draggable = false;
        }
      }
    }
  }
</script>
<style>
  .jqx-button {
    float: left;
  }

  .jqx-button:last-child {
    margin-left: 5px;
  }

  .clear {
    clear: both;
  }
</style>
